var _path, _rect, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCellPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5h-.5v.527c0 .212 0 .418.023.588a.99.99 0 00.27.592.99.99 0 00.592.27c.17.023.376.023.588.023H13.027c.212 0 .418 0 .588-.023a.99.99 0 00.592-.27.99.99 0 00.27-.592c.023-.17.023-.376.023-.588V2.5H10z",
    stroke: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 2.5,
    width: 11,
    height: 19,
    rx: 1.5,
    stroke: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14.5v-3M13 13h3",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 1,
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQogIDxwYXRoIGQ9Ik0xMCAyLjVIOS41VjNDOS41IDMuMDA5MDggOS41IDMuMDE4MTUgOS41IDMuMDI3MkM5LjQ5OTk1IDMuMjM5MjQgOS40OTk5MSAzLjQ0NTMgOS41MjI3NiAzLjYxNTI2QzkuNTQ4NTIgMy44MDY4NiA5LjYxMTI5IDQuMDI1NSA5Ljc5Mjg5IDQuMjA3MTFDOS45NzQ1IDQuMzg4NzEgMTAuMTkzMSA0LjQ1MTQ4IDEwLjM4NDcgNC40NzcyNEMxMC41NTQ3IDQuNTAwMDkgMTAuNzYwOCA0LjUwMDA1IDEwLjk3MjggNC41QzEwLjk4MTkgNC41IDEwLjk5MDkgNC41IDExIDQuNUgxM0MxMy4wMDkxIDQuNSAxMy4wMTgxIDQuNSAxMy4wMjcyIDQuNUMxMy4yMzkyIDQuNTAwMDUgMTMuNDQ1MyA0LjUwMDA5IDEzLjYxNTMgNC40NzcyNEMxMy44MDY5IDQuNDUxNDggMTQuMDI1NSA0LjM4ODcxIDE0LjIwNzEgNC4yMDcxMUMxNC4zODg3IDQuMDI1NSAxNC40NTE1IDMuODA2ODYgMTQuNDc3MiAzLjYxNTI2QzE0LjUwMDEgMy40NDUzIDE0LjUgMy4yMzkyNCAxNC41IDMuMDI3MkMxNC41IDMuMDE4MTUgMTQuNSAzLjAwOTA4IDE0LjUgM1YyLjVIMTRIMTBaIiBzdHJva2U9IndoaXRlIi8+DQogIDxyZWN0IHg9IjYuNSIgeT0iMi41IiB3aWR0aD0iMTEiIGhlaWdodD0iMTkiIHJ4PSIxLjUiIHN0cm9rZT0id2hpdGUiLz4NCiAgPHBhdGggZD0iTTE0LjUgMTQuNVYxMS41IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KICA8cGF0aCBkPSJNMTMgMTNIMTYiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQogIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTkiIHI9IjEiIGZpbGw9IndoaXRlIi8+DQo8L3N2Zz4=";
export { SvgCellPhone as ReactComponent };